export function buildSchema({
  domain,
  siteName,
  siteDescription,
  pageName,
}: {
  domain: string;
  siteName: string;
  siteDescription: string;
  pageName: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@id': `${domain}/#website`,
        '@type': 'WebSite',
        description: siteDescription,
        inLanguage: 'nl',
        name: siteName,
        url: `${domain}/`,
      },
      {
        '@id': `${domain}/#webpage`,
        '@type': 'WebPage',
        description: siteDescription,
        name: pageName,
        url: `${domain}`,
        isPartOf: { '@id': `${domain}/#website` },
        potentialAction: [{ '@type': 'ReadAction', target: [`${domain}`] }],
      },
    ],
  };
}
